import React, { useContext, FunctionComponent } from "react";

import { InputType } from '@components/library/inputs/Input.props';
import InputContainer from '@components/library/input_container/InputContainer';
import { ActionTypes, AssetDetailsDispatch, ValidationErrors } from '@components/asset/modal/tabs/edit/EditTabTypes';
import assetModalContext from '@components/asset/modal/tabs/edit/asset_modal_context';

interface AssetNameScopedContext {
  state: {
    editState: {
      assetName: string;
    };
    errorState: ValidationErrors[];
  };
  dispatch: AssetDetailsDispatch;
}

const AssetNameInput: FunctionComponent<{assetNameCopy?: string}> = ({ assetNameCopy }) => {
  const { state, dispatch }: AssetNameScopedContext = useContext(assetModalContext);
  const { assetName } = state.editState;
  const hasNameError = state.errorState.includes(ValidationErrors.MissingAssetName);
  return (
    <InputContainer
      submitAttempted={hasNameError}
      attributes={{
        name: 'name',
        onChange: (e: InputChangeEvent): void => dispatch(
          { type: ActionTypes.UpdateAsset, payload: { assetName: e.target.value } }
        ),
        type: InputType.Text,
        value: assetName,
      }}
      input={{ value: assetName, error: hasNameError ? t('Asset name required') : '' }}
      labelCopy={assetNameCopy || t('Asset Name')}
    />
  );
};

export default AssetNameInput;
